import React, { useEffect, useRef, useState } from 'react'

function useInterval(callback, delay) {
  const savedCallback = useRef()
  const [intId, setIntId] = useState()

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  const resetInterval = () => {
    if (intId) clearInterval(intId)

    function tick() {
      savedCallback.current()
    }

    if (delay !== null) {
      const id = setInterval(tick, delay)
      setIntId(id)
      return () => clearInterval(id)
    }
  }

  // Set up the interval.
  useEffect(() => {
    resetInterval()
  }, [delay])

  return {
    reset: resetInterval
  }
}

export default useInterval
